import React from 'react';
import { Link } from 'react-router-dom';
import SecurityBoxControls from '../SecurityBoxControls';
import SecurityBoxSubmit from '../SecurityBoxSubmit';

const getToLink = ({ tokenLink = null, partnerToken = null, loginLink = null }) => {
  if (tokenLink) {
    return `/welcome/login/${tokenLink}`;
  }

  if (partnerToken) {
    return `/welcome/partner/login/${partnerToken}`;
  }

  if (loginLink) {
    return loginLink;
  }

  return '/login';
};

export default ({ linkText, submitText, action, isDisabled, tokenLink, partnerToken, loginLink }) => {
  // eslint-disable-line
  return (
    <div style={{ width: 307, marginLeft: 50 }}>
      <SecurityBoxControls marginTop="true">
        <Link
          className="form-registation-link"
          to={getToLink({ tokenLink, partnerToken, loginLink })}
          style={{ marginTop: 10 }}
        >
          {linkText}
        </Link>
        <div style={{ float: 'right' }}>
          <SecurityBoxSubmit
            name="registerUserButton"
            submitAction={action}
            isDisabled={isDisabled}
            text={submitText}
          />
        </div>
      </SecurityBoxControls>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/registration/RegistrationSecurityBoxControls.jsx